import { Controller } from '@hotwired/stimulus';
import Toastify from 'toastify-js';

import 'toastify-js/src/toastify.css';

const BACKGROUNDS = {
  alert: 'linear-gradient(to right, #e74c3c, #c0392b)',
  error: 'linear-gradient(to right, #e74c3c, #c0392b)',
  notice: 'linear-gradient(to right, #00b09b, #96c93d)',
};

export default class extends Controller {
  static values = { flash: Array };

  // Stimulus invokes this once on connect (page load) AND again whenever
  // the data-*-flash-value attribute changes in place - including when
  // Turbo morphs the page (e.g. a form redirects back to the same URL) and
  // patches the attribute without removing/re-adding this element, which
  // means `connect()` alone would miss that update.
  flashValueChanged(messages) {
    (messages || []).forEach(([type, message]) => {
      Toastify({
        text: message,
        duration: 6000,
        newWindow: true,
        close: true,
        gravity: 'top', // `top` or `bottom`
        position: 'center', // `left`, `center` or `right`
        style: {
          background: BACKGROUNDS[type] || BACKGROUNDS.notice,
        },
      }).showToast();
    });
  }
}
